import { APP_EBOOKS_MODIFY } from "../actions/eBooks"

const initialState = {
  ebooks: [],
  isFetched: false
}

export default function appEbooksReducer(state = initialState, action) {
  switch (action.type) {
    case APP_EBOOKS_MODIFY:
      return Object.assign({}, state, action.payload)

    default:
      return state
  }
}
